import { render, staticRenderFns } from "./full-screen-centered-card.vue?vue&type=template&id=b10dab7a&scoped=true&"
import script from "./full-screen-centered-card.vue?vue&type=script&lang=js&"
export * from "./full-screen-centered-card.vue?vue&type=script&lang=js&"
import style0 from "./full-screen-centered-card.vue?vue&type=style&index=0&id=b10dab7a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10dab7a",
  null
  
)

export default component.exports